import type { optionType, Translationtype } from "utils";

interface IPaymentStatusProps {
  type: number | undefined;
  paymentOptions: optionType[];
  t: Translationtype;
}
export function PaymentStatus({
  type,
  paymentOptions,
  t,
}: IPaymentStatusProps) {
  function findPaymentStatus(id: number | undefined) {
    if (id === undefined || null) {
      return "-";
    }
    const value = paymentOptions.find((item) => item.value === id);
    return value?.label;
  }

  if (type === undefined || null) {
    return <></>;
  }

  function returnPaymentStatus(key: number) {
    switch (key) {
      case 0:
        // nincs fizetve
        return (
          <div className="badge badge-info whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 1:
        // Előleg fizetve
        return (
          <div className="badge badge-warning whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 2:
        // Teljes összeg fizetve
        return (
          <div className="badge badge-success whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 3:
        // visszatérítve
        return (
          <div className="badge badge-secondary whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 4:
        // eszköz fizetve kaució nem
        return (
          <div className="badge badge-primary whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 5:
        // gratis
        return (
          <div className="badge badge-accent whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 6:
        // fizetésre vár
        return (
          <div className="badge badge-ghost whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      case 7:
        // lemondva - a teljes foglalás visszatérítve
        return (
          <div className="badge badge-error whitespace-nowrap inline-block">
            {t(`Options.${findPaymentStatus(key)}` as any)}
          </div>
        );
      default:
        break;
    }
  }
  return <>{returnPaymentStatus(type)}</>;
}
